//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { faPlus } from '@fortawesome/pro-solid-svg-icons';

export default {
  name: 'WaysToSell',
  components: {
    CheckList: () => import('@/components/contributor/signup/CheckList.vue'),
  },
  data() {
    return {
      ways: [
        {
          title: this.$t('contributor.intro.ways_to_sell.on_demand.heading'),
          list: [
            this.$t('contributor.intro.ways_to_sell.on_demand.list_text_1'),
            this.$t('contributor.intro.ways_to_sell.on_demand.list_text_2'),
            this.$t('contributor.intro.ways_to_sell.on_demand.list_text_3'),
            this.$t('contributor.intro.ways_to_sell.on_demand.list_text_4'),
          ],
        },
        {
          title: this.$t('contributor.intro.ways_to_sell.subscription.heading'),
          list: [
            this.$t('contributor.intro.ways_to_sell.subscription.list_text_1'),
            this.$t('contributor.intro.ways_to_sell.subscription.list_text_2'),
            this.$t('contributor.intro.ways_to_sell.subscription.list_text_3'),
            this.$t('contributor.intro.ways_to_sell.subscription.list_text_4'),
          ],
        },
      ],
      faPlus,
    };
  },
};
